import React, { useState } from "react";
import { StdAcad, StdBiodata, StdHeader } from "./components";
import { Error404 } from "../../../Library/LoaderPage";

export function StdProfile(props) {
  const student = props?.student || "";

  const [currentTab, setCurrentTab] = useState(0);
  const navprofile = [
    { id: 1, name: "Biodata", component: <StdBiodata student={student} /> },
    { id: 2, name: "Academic Information", component: <StdAcad student={student} /> },
  ];
  return (
    <div id="my-profiles" className="container-fluid">
      {student ? (
        <div>
          <StdHeader student={student}>
            <div className="separator"></div>
            <div className="px-8">
              <ul className="nav nav-tabs nav-bold nav-tabs-line nav-tabs-line-3x">
                {navprofile.map((nav, index) => (
                  <li className="nav-item" key={index}>
                    <span
                      className={`cursor-pointer nav-link font-weight-bolder h5 ${index === currentTab ? "active" : ""
                        }`}
                      onClick={() => setCurrentTab(index)}
                    >
                      {nav.name}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </StdHeader>

          <div className="mt-8">
            {navprofile[currentTab].component}
          </div>
        </div>
      ) : (
        <Error404 />
      )}
    </div>
  );
}
